export const depositAmountPattern = /^([0-9]+)(?:\.([0-9]{1,2}))?$/;

export const parseDepositAmountCents = (value?: string) => {
  const match = value?.match(depositAmountPattern);

  if (!match) return null;

  const wholeUnits = Number(match[1]);
  const fractionalUnits = Number((match[2] || '').padEnd(2, '0'));
  const amountCents = wholeUnits * 100 + fractionalUnits;

  return Number.isSafeInteger(amountCents) && amountCents > 0 ? amountCents : null;
};
